import React from 'react';
import { Popover } from '@mui/material';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';

interface EmojiPickerProps {
  anchorEl: HTMLElement | null;
  onEmojiSelect: (emoji: any) => void;
  onClose: () => void;
}

const EmojiPicker: React.FC<EmojiPickerProps> = ({ anchorEl, onEmojiSelect, onClose }) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Picker
        data={data}
        onEmojiSelect={onEmojiSelect}
        theme="light"
        previewPosition="none"
        skinTonePosition="none"
      />
    </Popover>
  );
};

export default EmojiPicker;
